import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nome-sistema',
  templateUrl: './nome-sistema.component.html',
  styleUrls: ['./nome-sistema.component.css']
})
export class NomeSistemaComponent implements OnInit {

  @Input() public nomeSistema: string;

  constructor() { }

  ngOnInit() {
  }

}
